import { Input } from 'antd'
import { createStyles } from 'antd-style'

import { pick } from '@eastcoal/common/utils/object'

import { useRemoteTableStore } from '../../Store/hooks/useStore'
import { SearchInputProps } from '../interface'

const useStyles = createStyles(({ token }) => ({
  search: {
    width: 320
  }
}))

export const SearchInput = ({
  className,
  style,
  fields,
  onSearch
}: SearchInputProps) => {
  const { request, requestParams } = useRemoteTableStore(state =>
    pick(state, ['request', 'requestParams'])
  )

  const title = `输入 ${fields.join(' | ')} 模糊查询`

  const handleSearchChange = (value: string) => {
    request({
      ...requestParams,
      search: onSearch?.(value) ?? value,
      current: 1
    })
  }

  const { cx, styles } = useStyles()

  return (
    <Input.Search
      allowClear
      enterButton
      className={cx(styles.search, className)}
      placeholder={title}
      style={style}
      title={title}
      onPressEnter={e => handleSearchChange(e.currentTarget.value)}
      onSearch={handleSearchChange}
    />
  )
}
